var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-timeline',{staticClass:"pad"},[_c('el-timeline-item',[_c('h3',[_vm._v("绝对禁忌症")]),_c('AbsoluteContradictions')],1),_c('el-timeline-item',[_c('h3',[_vm._v("既往病史")]),_c('MedicalHistory',{ref:"MedicalHistoryRef",attrs:{"teleNum":_vm.teleNum,"disabled":_vm.disabled}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }